export const msalConfig = {
    auth: { 
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID, 
        authority: process.env.REACT_APP_TENANT_ID,
        redirectUri: process.env.REACT_APP_REDIRECT_URI,  
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "email",
        "User.Read"
    ]
};